/** Shared engine types (static content). The account itself is the bot's document (`./bot`). */

/** The web game ships French and English only (the bot also has Spanish). */
export type Lang = 'fr' | 'en';
export const LANGS: readonly Lang[] = ['fr', 'en'];

export type ItemType = 'characters' | 'weapons' | 'shields' | 'pets';
/** Bot order (`data/items.ts#types`). */
export const ITEM_TYPES: readonly ItemType[] = ['characters', 'weapons', 'shields', 'pets'];

export type Element = 'Neutral' | 'Strength' | 'Intelligence' | 'Chance' | 'Agility' | 'Multi';
export const ELEMENTS: readonly Exclude<Element, 'Multi'>[] = ['Neutral', 'Strength', 'Intelligence', 'Chance', 'Agility'];

export type Localized = Record<Lang, string>;

export interface GameItem {
  id: number;
  type: ItemType;
  tier: number;
  element: Element;
  /** Discord emoji token `<:name:id>` — resolved by the client asset packs. */
  emoji: string;
  image: string;
  tags: string[];
  name: Localized;
}

/** Item descriptions of one language by type and id (loaded on demand: `loadItemDescriptions`). */
export type ItemDescriptions = Record<ItemType, Record<number, string>>;

export interface Tier {
  id: number;
  emoji: string;
  color: string;
  base: number;
  name: Localized;
}

export interface RarityLevel {
  required: number;
  /** Cumulative-probability slices, index 0 = highest tier (Exotic). */
  tiers: number[];
  display: number[];
}

export interface LevelEntry {
  xp: number;
  fight: number;
}

export interface League {
  name: string;
  points: number;
  emoji: string;
  rewards: { fake: number; loot: number };
}

export interface Difficulty {
  name: string;
  emoji: string;
  difficulty: number;
  cost: number;
}

export type DifficultyKey = 'normal' | 'hard' | 'nightmare';
export const DIFFICULTY_KEYS: readonly DifficultyKey[] = ['normal', 'hard', 'nightmare'];
